import {getData} from "./api/get-data";
import {parseCitiesData} from "./data/parse-cities-data";
import {onEscPressModalHandler} from "./on-esc-press-modal-handler";
import {renderCities} from "./render-alphabet-cities";
import {renderContactContent} from "./render-contact-content";
import {getPage} from "./require/get-page";

const contactB2CElement = document.querySelector(`.franchise-page__B2CContent--right`);

export const initFrPage = () => {
  const callbackButton = document.querySelector(`.franchise-page__callbackButton`);
  const callbackModalElement = document.querySelector(`.js--callbackModal`);

  if (callbackButton) {
    callbackButton.addEventListener(`click`, () => {
      callbackModalElement.classList.add(`modal--show`);
      callbackModalElement.dataset.mode = `form`;
      document.addEventListener(`keydown`, onEscPressModalHandler);
    });
  }

  const phoneInputElement = callbackModalElement.querySelector(`input[name="phone"]`);

  const sendRequestButton = document.querySelector(`.js--sendRequestButton`);

  sendRequestButton.addEventListener(`click`, () => {
    const nameInput = callbackModalElement.querySelector(`input[name="name"]`);
    const emailInput = callbackModalElement.querySelector(`input[name="email"]`);
    const cityInput = callbackModalElement.querySelector(`input[name="city"]`);
    const captureInputElement = callbackModalElement.querySelector(`input[name="capture"]`);

    const wrapButtonElement = callbackModalElement.querySelector(`.modal__buttonWrap`);
    const errorMessageElement = callbackModalElement.querySelector(`.modal__errorMessage`);

    wrapButtonElement.dataset.mode = `progress`;
    errorMessageElement.textContent = ``;

    getData({
      [`set_business_feedback`]: {
        [`name`]: nameInput.value,
        [`phone`]: phoneInputElement.value,
        [`email`]: emailInput.value,
        [`city`]: cityInput.value,
        [`capture`]: captureInputElement.value,
      }
    })
    .then((response) => {
      if (response.result === `OK`) {
        callbackModalElement.dataset.mode = `result`;

        // callbackModalElement.classList.remove(`modal--show`);
        // document.removeEventListener(`keydown`, onEscPressModalHandler);

        nameInput.value = ``;
        phoneInputElement.value = ``;
        emailInput.value = ``;
        cityInput.value = ``;
      }
      if (response.result === `ERROR`) {
        errorMessageElement.textContent = response.error;
      }
    })
    .finally(() => {
      wrapButtonElement.dataset.mode = `button`;
    });
  });

  const isOnlyOneShop = Object.keys(shopListData).length === 1;

  const toggleWrapElement = document.querySelector(`.franchise-page__toggleWrap`);
  toggleWrapElement.dataset.show = !isOnlyOneShop;
  const contactWrapElement = document.querySelector(`.franchise-page__contact`);
  contactWrapElement.dataset.show = !isOnlyOneShop;

  const contentElement = document.querySelector(`.franchise-page__content`);
  contentElement.dataset.mode = `b2c`;

  const offerToggles = document.querySelectorAll(`.franchise-page__toggle input`);
  Array.from(offerToggles).forEach((input) => {
    input.addEventListener(`change`, () => {
      if (!input.checked) {
        return;
      }
      const mode = input.value;
      contentElement.dataset.mode = mode;
    });
  });

  const B2CElement = document.querySelector(`.franchise-page__B2CWrap`);
  B2CElement.dataset.mode = isOnlyOneShop ? `one` : `more`;


  const cityB2CElement = document.querySelector(`.franchise-page__B2CContent--left`);
  if (!isOnlyOneShop) {
    const cities = parseCitiesData(shopListData, shopInfoData);
    renderCities(contactB2CElement, cityB2CElement.querySelector(`.cities__list`), cities);
  }

  if (shopInfoData.shop_id) {
    getPage(shopInfoData.shop_id, (data) => {
      renderContactContent(contactB2CElement.querySelector(`div`), data);
    });
  }
};

